import { useCallback, useRef } from 'react';
import { colord } from 'colord';
import { resolveColorStyle } from '../_helpers';

const MAX_ITERATIONS = 5;
const MAX_THRESHOLD = 2;

export function useColor() {
  const isRunning = useRef(false);

  const calculateFilter = useCallback(
    (
      inputColor,
      iterationLimit = MAX_ITERATIONS,
      confidence = MAX_THRESHOLD
    ) => {
      let ret = {
        filter: '',
        loss: Infinity,
      };
      if (isRunning.current === false) {
        isRunning.current = true;

        const convertedColor = colord(inputColor).toRgb();
        for (let i = 0; i < iterationLimit; i++) {
          const result = resolveColorStyle(convertedColor);
          if (result.loss > confidence) {
            console.log('Confidence: ', result.loss);
            ret.loss = result.loss;
            continue;
          } else {
            ret = result;
            break;
          }
        }

        if (ret.loss > confidence) {
          ret.warning = `Cannot convert the chosen color after ${iterationLimit} attempts.`;
        }
        isRunning.current = false;
      }

      return { ...ret };
    },
    []
  );

  return { calculateFilter };
}
